import React, { Component } from 'react';

class Atendimento extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="col-xs-6">
                <div className="b-contacts__address">
                    <div className="b-contacts__address-hours">
                        <h2 className="s-titleDet wow zoomInUp" data-wow-delay="0.5s">Atendimento</h2>
                        <div
                            className="b-contacts__address-hours-main wow zoomInUp"
                            data-wow-delay="0.5s"
                            style={{
                                backgroundColor: "#3c3c3c",
                                color: "#f5f5f5",
                                borderRadius: 8,
                                padding: 16,
                            }}
                        >
                            <div className="row">
                                <div className="col-md-12 col-xs-12">
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <span><i className="fa fa-calendar-o" style={{ marginRight: 8 }}></i>Segunda-feira</span>
                                            <strong>08:30 – 18:00</strong>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <span><i className="fa fa-calendar-o" style={{ marginRight: 8 }}></i>Terça-feira</span>
                                            <strong>08:30 – 18:00</strong>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <span><i className="fa fa-calendar-o" style={{ marginRight: 8 }}></i>Quarta-feira</span>
                                            <strong>08:30 – 18:00</strong>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <span><i className="fa fa-calendar-o" style={{ marginRight: 8 }}></i>Quinta-feira</span>
                                            <strong>08:30 – 18:00</strong>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <span><i className="fa fa-calendar-o" style={{ marginRight: 8 }}></i>Sexta-feira</span>
                                            <strong>08:30 – 18:00</strong>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <span><i className="fa fa-calendar-check-o" style={{ marginRight: 8 }}></i>Sábado</span>
                                            <strong>08:30 – 15:30</strong>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0" }}>
                                            <span><i className="fa fa-calendar-times-o" style={{ marginRight: 8 }}></i>Domingo</span>
                                            <strong style={{ color: "#ff8a80" }}>Fechado</strong>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="b-contacts__address-info">
                        <h2 className="s-titleDet wow zoomInUp" data-wow-delay="0.5s">Fale conosco</h2>
                        <address
                            className="b-contacts__address-info-main wow zoomInUp"
                            data-wow-delay="0.5s"
                            style={{
                                backgroundColor: "#3c3c3c",
                                color: "#f5f5f5",
                                borderRadius: 8,
                                padding: 16,
                            }}
                        >
                            <div className="b-contacts__address-info-main-item" style={{ padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                <div className="row" style={{ alignItems: "flex-start" }}>
                                    <div className="col-lg-4 col-md-4 col-xs-12">
                                        <span className="fa fa-home" style={{ marginRight: 8 }}></span>
                                        Endereço
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-xs-12">
                                        <p style={{ marginBottom: 6 }}>{this.props.revenda.peendereco_fiscal} {this.props.revenda.peendereco_fiscal_numero} {this.props.revenda.peendereco_fiscal_compl} - {this.props.revenda.pebairro_fiscal}<br />{this.props.revenda.pecidade}-{this.props.revenda.peuf}</p>
                                        <p style={{ marginBottom: 0 }}>Rua Andrade Neves - 583 - Vila Helena - Santo André - SP</p>
                                    </div>
                                </div>
                            </div>
                            <div className="b-contacts__address-info-main-item" style={{ padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-xs-12">
                                        <span className="fa fa-phone" style={{ marginRight: 8 }}></span>
                                        Telefone
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-xs-12">
                                        <em><a href={"tel:" + retiraMascara(this.props.revenda.petelefone1, "link")} style={{ color: "#fff" }}>{retiraMascara(this.props.revenda.petelefone1)}</a></em>
                                    </div>
                                </div>
                            </div>
                            {
                                this.props.revenda.petelefone2 !== undefined && this.props.revenda.petelefone2.trim().length > 0 ?
                                    (
                                        <div className="b-contacts__address-info-main-item" style={{ padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-xs-12">
                                                    <span className="fa fa-whatsapp" style={{ marginRight: 8 }}></span>
                                                    Whatsapp
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-xs-12">
                                                    <em><a href={'https://api.whatsapp.com/send?phone=55' + retiraMascara(this.props.revenda.petelefone2, "link")} style={{ color: "#fff" }}>{retiraMascara(this.props.revenda.petelefone2)}</a></em>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : <span></span>
                            }
                            {
                                this.props.revenda.petelefone3 !== undefined && this.props.revenda.petelefone3.trim().length > 0 ?
                                    (
                                        <div className="b-contacts__address-info-main-item" style={{ padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-xs-12">
                                                    <span className="fa fa-whatsapp" style={{ marginRight: 8 }}></span>
                                                    Whatsapp
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-xs-12">
                                                    <em><a href={'https://api.whatsapp.com/send?phone=55' + retiraMascara(this.props.revenda.petelefone3, "link")} style={{ color: "#fff" }}>{retiraMascara(this.props.revenda.petelefone3)}</a></em>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : <span></span>
                            }
                            <div className="b-contacts__address-info-main-item" style={{ padding: "8px 0" }}>
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-xs-12">
                                        <span className="fa fa-envelope" style={{ marginRight: 8 }}></span>
                                        E-mail
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-xs-12">
                                        <em><a href={"mailto:" + this.props.revenda.peemail} style={{ color: "#fff" }}>{this.props.revenda.peemail}</a></em>
                                    </div>
                                </div>
                            </div>
                        </address>
                    </div>
                </div>
            </div>
        );
    }
}

function retiraMascara(value, type = "texto") {
    var numero = '';
    if (value !== undefined) {
        numero = value.replace('_', '');
        if (type === "link") {
            numero = numero.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
        }
    }
    return numero;
}

export default Atendimento;